class PortfolioComponentSlider extends HTMLElement {
  constructor() {
    super()
    this.initFlickity()
  }

  initFlickity(designMode) {
    let desktopFlickity = false
    let mobileFlickity = false
    let flkty

    if (this.dataset.desktopCarousel === 'true') desktopFlickity = true
    if (this.dataset.mobileCarousel === 'true') mobileFlickity = true

    if (desktopFlickity) {
      this.flickityConfig(designMode)
      return
    }
    if (mobileFlickity && window.innerWidth < 750) {
      flkty = this.flickityConfig(designMode)
    }
    const query = matchMedia('(max-width: 749px)')
    const _self = this
    query.addEventListener('change', function (e) {
      if (e.matches) {
        flkty = _self.flickityConfig(designMode)
        return
      }
      flkty.destroy()
    })
    return
  }

  flickityConfig(designMode) {
    const carousel = this.querySelector('.carousel[data-carousel*="carousel-"]')
    const options = {
      pageDots: true,
      prevNextButtons: true,
      arrowShape: 'M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z',
      cellAlign: 'center', // Align cells to the center
      freeScroll: true,    // Enable free scrolling
      contain: true,
      wrapAround: true
    }
    const flkty = new Flickity(carousel, { ...options })
    if (designMode) {
      flkty.resize()
    }
    return flkty
  }
}

customElements.define('portfolio-component-slider', PortfolioComponentSlider)
